<template>
  <div class="cwDropdownBoxWrapper dropdownGroup" v-show="isVisible">
    <h3 class="dropdownGroup-label">
      <span v-if="cmpConfig.component.decorator.label_module">{{
        getCactusString(cmpConfig.component.decorator.label_module)
      }}</span>
    </h3>
    <div class="dropdownGroup-item">
      <div>
        <span>{{ getCactusString(cmpConfig.component.decorator.label_static) }}</span>
      </div>

      <cw-dropdown
        class="dropdownGroup-dropdown dropdown-s"
        v-model="selectedData"
        v-bind="dropdownProps"
        @input="valueChanged"
      ></cw-dropdown>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import _find from 'lodash/find';
import cwDropdown from './cwDropdown.vue';
import expertviewMixin from './experviewMixin';

export default {
  name: 'CwDropdownWrapper',
  components: { cwDropdown },
  mixins: [expertviewMixin],
  props: {
    cmpConfig: {
      type: Object,
      default: () => {},
      required: true
    },
    fwParams: {
      type: Array,
      default: () => [],
      required: true
    },
    valueSet: {
      type: Array,
      default: () => [],
      required: true
    }
  },
  data() {
    return {
      selectedData: undefined,
      rulesValue: []
    };
  },
  created() {
    this.$log.debug('cwDropdownBoxWrapper::created()', this.cmpConfig);

    if (this.ruleSubscriber.length > 0) {
      this.applyRules();
    }

    if (this.ruleProvider.length > 0) {
      const defaultValue = this.cmpConfig.value.default.default;
      this.applyRuleProvider(defaultValue);
    }

    this.selectedData = _find(this.valueSet, {
      value: this.valueFromFw.toString()
    });

    this.valueChanged(this.selectedData);
  },
  computed: {
    ...mapGetters(['latestAppData', 'getRule']),

    dropdownProps() {
      return {
        value: this.selectedData,
        options: this.valueSet || [],
        valueKey: 'value',
        labelKey: 'label'
      };
    },

    listContent() {
      if (this.cmpConfig.rule_subscriber && this.valuesWithRules) {
        let valKey = this.cmpConfig.rule_subscriber[0].rule[0] || 'default';
        if (this.cmpConfig.value[valKey]) {
          return this.cmpConfig.value[valKey];
        }
      }

      return this.cmpConfig.value.default;
    },

    valuesWithRules: {
      get() {
        return this.rulesValue.map(rule => this.getRule(rule)).every(el => el === true);
      },
      set(newVal) {
        this.rulesValue = newVal;
      }
    },

    valueFromFw() {
      let fwParams = this.getFwApp();
      return this.getAppValue(fwParams.app, fwParams.param) || this.defaultValue;
    },

    cmpLabel() {
      return this.getCactusString(this.cmpConfig.component.decorator.label_module);
    }
  },
  methods: {
    ...mapActions(['setRuleProvider']),

    valueChanged(newVal) {
      let fwApp = this.getFwApp();
      this.selectedData = newVal;
      this.applyRuleProvider(newVal.value);

      this.$log.debug('cwDropdownBoxWrapper::valueChanged', {
        app: fwApp.app,
        parameter: fwApp.param,
        value: Number(newVal.value)
      });

      this.setExpertViewParams({
        app: fwApp.app,
        parameter: fwApp.param,
        value: Number(newVal.value)
      });
    },

    handleFallbackPolicy(policy) {
      switch (policy) {
        case 'policy_default':
          return _find(this.cmpConfig.value.default.values, {
            value: this.cmpConfig.value.default.default
          });
        case 'policy_hidden':
          this.isVisible = false;
          return;
        default:
          break;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.dropdownGroup {
  padding-bottom: 24px;
  width: 96px;
  margin: 0 auto;

  &-label {
    @include textSmall;
    color: $bluey-grey;
    margin: 2px 0 4px 4px;
  }

  &-item {
    background-color: $cloudy-blue-20;
    border: 1px solid $cloudy-blue;
    border-radius: 8px;
    height: 80px;

    & > :first-child {
      display: block;
      height: 40px;
      line-height: 40px;
      border-bottom: 1px solid $cloudy-blue;
      font-size: 14px;
      color: $petrol;
      text-align: center;

      & > :last-child {
        color: $cloudy-blue;
      }
    }

    & > :last-child {
      height: 40px;
      display: block;
      font-size: 14px;
      color: $petrol;
    }
  }
}
</style>
